var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa-stack small"},[_c('i',{staticClass:"fas fa-circle fa-stack-2x"}),_vm._v(" "),_c('i',{class:['fas fa-dollar-sign fa-stack-1x small fa-inverse', { 'warning-color' : _vm.isWarning }]})])}
var staticRenderFns = []

export { render, staticRenderFns }